// Central backend URL for the app
// TODO local testing: set VITE_BACKEND_URL=http://localhost:4000 in frontend/.env.development.local
const fallbackBackendUrl = import.meta.env.DEV
  ? 'http://localhost:4000'
  : 'https://pranaveclinic.com';

export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || fallbackBackendUrl;
